import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";

const MessageFields = ({ blog, messages }) => {
  const { state } = useContext(UserContext);
  return (
    <>
      {messages?.map((message) => {
        return (
          <>
            {state ? (
              <>
                {blog.user._id === message.messageBy?._id ? (
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex flex-start align-items-center">
                        <img
                          className="rounded-circle shadow-1-strong me-3 rm-profilepic"
                          src={
                            true
                              ? `${message.messageBy?.profilepic}`
                              : // : defaultPic
                                ""
                          }
                          alt="avatar"
                          width="40"
                          height="40"
                        />
                        <div>
                          <h6 className="fw-bold text-primary mb-1">
                            {message.messageBy?.name}{" "}
                            <span className="fw-light">[Blogger]</span>
                          </h6>
                          <p className="text-muted small mb-0 msg-txt">
                            shared publicly-{message.commentOn}
                          </p>
                        </div>
                      </div>

                      <p className="my-1 ps-3 pb-2">{message.text}</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex flex-start align-items-center">
                          <img
                            className="rounded-circle shadow-1-strong me-3 rm-profilepic"
                            src={
                              true
                                ? `${message.messageBy?.profilepic}`
                                : // : defaultPic
                                  ""
                            }
                            alt="avatar"
                            width="40"
                            height="40"
                          />
                          <div>
                            <h6 className="fw-bold text-primary mb-1">
                              {message.messageBy?.name}
                            </h6>
                            <p className="text-muted small mb-0 msg-txt">
                              Shared publicly-{message.commentOn}
                            </p>
                          </div>
                        </div>

                        <p className="my-1 ms-3 pb-2">{message.text}</p>
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </>
        );
      })}
    </>
  );
};

export default MessageFields;
